export const META_PIXEL_ID = '928392859622651'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

const SCRIPT_ID = 'meta-pixel-script'
const NOSCRIPT_ID = 'meta-pixel-noscript'

/**
 * Injects the Meta Pixel base code (equivalent to the snippet Meta provides for
 * <head>) and fires the initial PageView. Safe to call more than once.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  if (!window.fbq) {
    const fbq: Window['fbq'] = function (...args: unknown[]) {
      const self = window.fbq as NonNullable<Window['fbq']>
      if (self.callMethod) self.callMethod.apply(self, args)
      else (self.queue as unknown[]).push(args)
    } as NonNullable<Window['fbq']>

    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
  }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  if (!document.getElementById(NOSCRIPT_ID)) {
    const noscript = document.createElement('noscript')
    noscript.id = NOSCRIPT_ID
    const img = document.createElement('img')
    img.height = 1
    img.width = 1
    img.style.display = 'none'
    img.alt = ''
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
    noscript.appendChild(img)
    document.body.appendChild(noscript)
  }

  window.fbq?.('init', pixelId)
  // trackSingle sends the event ONLY to our pixel. Using plain `track` would
  // also fire it on any other pixel that a third-party script initialized on
  // the page (checkout widgets, embeds, etc.).
  window.fbq?.('trackSingle', pixelId, 'PageView')
}

/**
 * Fires a standard Meta Pixel event (e.g. InitiateCheckout, Lead) on our pixel
 * only, so third-party pixels loaded on the page never receive our events.
 */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
  pixelId: string = META_PIXEL_ID,
): void {
  if (typeof window === 'undefined') return
  window.fbq?.('trackSingle', pixelId, event, params)
}
